module.exports = __webpack_public_path__ + "img/us.36ab476e.svg";